import type { UUID } from '@cobliteam/common-types';

import Button from '@cobliteam/ui/components/Button';

import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';

interface GeofenceTitleProps {
  selectedGeofencesIds: UUID[];
  title?: string;
  size?: 'condensed' | 'regular';
}

const GeofenceTitle = ({ selectedGeofencesIds, title, size }: GeofenceTitleProps) => {
  const buttonTitle = title || `Locais ${selectedGeofencesIds?.length > 0 ? `(${selectedGeofencesIds?.length})` : ''}`;

  return (
    <Button size={size} variant='text' type='button' startIcon={<LocationOnRoundedIcon />}>
      {buttonTitle}
    </Button>
  );
};

export default GeofenceTitle;
